import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import FAIcon from "../FAIcon/FAIcon";
export const ReactSelectLookupButton = (props) => {
    var _a, _b, _c;
    return (_jsx("button", Object.assign({}, props, { type: (_a = props.type) !== null && _a !== void 0 ? _a : "button", className: classNames((_b = props.className) !== null && _b !== void 0 ? _b : "", "btn btn-outline-primary lookup-button"), children: (_c = props.children) !== null && _c !== void 0 ? _c : (_jsx(FAIcon, { icon: "search-plus", srText: "Open advanced search" })) })));
};
const createReactSelectLookupStyles = (hideButton) => (styles) => (Object.assign(Object.assign({}, styles), (hideButton
    ? {}
    : {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
    })));
const ReactSelectWithLookupModal = (props) => {
    return (_jsxs("div", { className: "d-flex w-100", children: [_jsx("div", { className: "flex-grow-1", style: { minWidth: 0 }, children: props.select(createReactSelectLookupStyles(props.hideButton)) }), props.lookupButton] }));
};
export default ReactSelectWithLookupModal;
